import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const timerangeControlFeatureFlag: FeatureFlagType = {
  name: 'timerange_controls',
  fallback: false,
};

export const useIsTimerangeControlEnabled = () => {
  const [, isTimerangeControlEnabled] = useFeatureFlag(
    timerangeControlFeatureFlag,
  );

  return isTimerangeControlEnabled;
};
